'use client'

import { PropsWithChildren } from 'react'
import { TabsContext } from './tabs-context'
import { useTabs, UseTabsProps } from './use-tabs'

export type TabsProps = PropsWithChildren<UseTabsProps>

export function Tabs(props: TabsProps) {
  const { children, ...tabsProps } = props

  const contextValue = useTabs(tabsProps)

  return (
    <TabsContext.Provider value={contextValue}>{children}</TabsContext.Provider>
  )
}
